import React from "react";
import MarketingArt from "../MarketingArt.jsx";

// Feature card: a compact square thumbnail where the icon tile used to sit,
// then the title and description.
//
// The image REPLACES the icon rather than joining it — two marks in a 3x3 grid
// competed with each other and with the hero. `icon` is still accepted and used
// as the fallback, so a card whose image has not been generated (or 404s)
// degrades to exactly what it looked like before.
const FeatureCard = ({ icon: Icon, image, title, description }) => {
  const iconTile = (
    <div className="w-full h-full rounded-[12px] bg-[color-mix(in_srgb,var(--land-primary)_10%,transparent)] text-[var(--land-primary)] grid place-items-center">
      <Icon size={21} />
    </div>
  );

  return (
    <div
      className={[
        "group card-pop relative bg-[var(--land-panel)] border border-[var(--land-line)] rounded-[16px] p-7 h-full overflow-hidden",
        "before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-[3px] before:landing-aurora",
        "before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100",
      ].join(" ")}
    >
      <div className="w-[72px] h-[72px] rounded-[12px] overflow-hidden border border-[var(--land-line)] bg-[var(--land-panel-2)] mb-4 transition-transform duration-300 group-hover:scale-105">
        {image ? (
          <MarketingArt src={image} className="w-full h-full object-cover block" fallback={iconTile} />
        ) : (
          iconTile
        )}
      </div>

      <h3 className="font-disp text-[19px] font-bold tracking-[-.01em] text-[var(--land-ink)]">{title}</h3>
      <p className="text-[var(--land-muted)] text-[16px] mt-2 leading-[1.62]">{description}</p>
    </div>
  );
};

export default FeatureCard;
